/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deactivateMarkedBoxProducts } from '../fn/deactivation-controller/deactivate-marked-box-products';
import { DeactivateMarkedBoxProducts$Params } from '../fn/deactivation-controller/deactivate-marked-box-products';

@Injectable({ providedIn: 'root' })
export class DeactivationControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deactivateMarkedBoxProducts()` */
  static readonly DeactivateMarkedBoxProductsPath = '/box-products/deactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateMarkedBoxProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateMarkedBoxProducts$Response(params?: DeactivateMarkedBoxProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deactivateMarkedBoxProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deactivateMarkedBoxProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateMarkedBoxProducts(params?: DeactivateMarkedBoxProducts$Params, context?: HttpContext): Observable<void> {
    return this.deactivateMarkedBoxProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
